import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import SearchContainer from './components/SearchContainer';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Accommodation from './pages/Accommodation';
import WhatToVisit from './pages/WhatToVisit';
import ShopMarketsRentals from './pages/ShopMarketsRentals';
import RestaurantsClubsBars from './pages/RestaurantsClubsBars';
import SearchResults from './components/SearchResults';
import Contact from './pages/Contact';
import OurOffer from './pages/OurOffer';
import TripsAndExcursions from './pages/TripsAndExcursions';
import ContactLive from './pages/ContactLive';
import ServiceInformation from './pages/ServiceInformation';
import Events from './pages/Events';
import PlaceDetails from './components/PlaceDetails';
import CookieConsent from './components/CookieConsent'; // Import CookieConsent komponente
import TermsOfUse from './pages/TermsOfUse'; // Importujte stranicu Terms of Use

function App() {
    const [backgroundImage, setBackgroundImage] = useState("");
    const [withLayer, setWithLayer] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/") {
            const images = [
                "/images/background.jpg",
                "/images/background1.jpg",
                "/images/background2.jpg",
            ];

            const randomIndex = Math.floor(Math.random() * images.length);
            setBackgroundImage(images[randomIndex]);
            setWithLayer(true);
        } else {
            setBackgroundImage("");
            setWithLayer(false);
        }
    }, [location.pathname]);

    return (
        <div className="App">
            <CookieConsent /> {/* Dodajemo CookieConsent prozor */}
            <div
                className={`background-container ${withLayer ? 'with-layer' : ''}`}
                style={{
                    backgroundImage: backgroundImage
                        ? `url(${backgroundImage})`
                        : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "top center",
                    backgroundRepeat: "no-repeat",
                    minHeight: "calc(100vh - 120px)",
                }}
            >
                <Header />
                <Routes>
                    <Route path="/" element={<SearchContainer />} />
                    <Route path="/accommodation" element={<Accommodation />} />
                    <Route path="/accommodations/:slug" element={<Accommodation />} />
                    <Route path="/search-results" element={<SearchResults />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/our-offer" element={<OurOffer />} />
                    <Route path="/accommodations/:slug/trips-excursions" element={<TripsAndExcursions />} />
                    <Route path="/accommodations/:slug/contact-live" element={<ContactLive />} />
                    <Route path="/accommodations/:slug/services" element={<ServiceInformation />} />
                    <Route path="/accommodations/:slug/events" element={<Events />} />
                    <Route path="/accommodations/:slug/what-to-visit" element={<WhatToVisit />} />
                    <Route path="/accommodations/:slug/:category_slug/:placeId" element={<PlaceDetails />} />
                    <Route path="/accommodations/:slug/restaurants-clubs-bars" element={<RestaurantsClubsBars />} />
                    <Route path="/accommodations/:slug/shops-and-markets" element={<ShopMarketsRentals />} />
                    <Route path="/TermsOfUse" element={<TermsOfUse />} /> {/* Dodajemo rutu za TermsOfUse */}
                    <Route path="*" element={<div>Page Not Found</div>} />

                    
                </Routes>
            </div>
            <Footer />
        </div>
    );
}

const AppWrapper = () => (
    <Router>
        <App />
    </Router>
);

export default AppWrapper;
